import React from 'react';
import PropTypes from 'prop-types';

const blockEl = 'ui__tab-panel';

const TabPanel = ({ value, index, children = null }) => {
  if (value !== index) {
    return null;
  }

  return <div className={blockEl}>{children}</div>;
};

TabPanel.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.node
};

export default TabPanel;
